import {
  ActionTypes,
  RequestActionCreator,
  RequestSuccessActionCreator,
  RequestFailureActionCreator,
  ResetActionCreator,
} from "./types";

export const request: RequestActionCreator = (app) => {
  return {
    type: ActionTypes.CP_APP_EVAL_SKUS_REQUEST,
    app,
  };
};

export const requestSuccess: RequestSuccessActionCreator = (data) => {
  return {
    type: ActionTypes.CP_APP_EVAL_SKUS_REQUEST_SUCCESS,
    data,
  };
};

export const requestFailure: RequestFailureActionCreator = (error) => {
  return {
    type: ActionTypes.CP_APP_EVAL_SKUS_REQUEST_FAILURE,
    error,
  };
};

export const reset: ResetActionCreator = () => {
  return {
    type: ActionTypes.CP_APP_EVAL_SKUS_RESET,
  };
};
